import React, { useEffect, useState } from "react";
import CompanyPayments from "./CompanyPayments";
import api from "../Service/api";
import "./Purchases.css";

const CompanyPaymentsPage = () => {
  const [payments, setPayments] = useState(null);
  const [loading, setLoading] = useState(false);

  const getToday = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const [startDate, setStartDate] = useState(getToday());
  const [endDate, setEndDate] = useState(getToday());

  const fetchPayments = async (start, end) => {
    setLoading(true);
    try {
      const params = {};
      if (start) params.startDate = start;
      if (end) params.endDate = end;

      const res = await api.get("/api/inventory/grouped-by-vendor", { params });
      if (res.data.code === 1) {
        setPayments(res.data.additionalDetail || {});
      } else {
        setPayments({});
      }
    } catch (err) {
      console.error("Error fetching company payments", err);
      setPayments({});
    } finally {
      setLoading(false);
    }
  };

  // Load today's payments on mount
  useEffect(() => {
    fetchPayments(startDate, endDate);
  }, []);

  const applyFilters = () => fetchPayments(startDate, endDate);

  const clearFilters = () => {
    setStartDate("");
    setEndDate("");
    fetchPayments();
  };

  return (
    <div className="purchase-container">
      <h2 style={{ marginBottom: 20 }}>Company Payments</h2>

      {/* Filter UI – pre-filled with today */}
      <div style={{ marginBottom: 20, display: "flex", gap: 15, alignItems: "flex-end", flexWrap: "wrap" }}>
        <div>
          <label style={{ display: "block", marginBottom: 5, fontWeight: 500 }}>From:</label>
          <input
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            style={{
              padding: "8px 12px",
              border: "1px solid #cbd5e1",
              borderRadius: 6,
              color: "#000",
              backgroundColor: "#fff",
              fontSize: 14
            }}
          />
        </div>
        <div>
          <label style={{ display: "block", marginBottom: 5, fontWeight: 500 }}>To:</label>
          <input
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            min={startDate}
            style={{
              padding: "8px 12px",
              border: "1px solid #cbd5e1",
              borderRadius: 6,
              color: "#000",
              backgroundColor: "#fff",
              fontSize: 14
            }}
          />
        </div>
        <button
          onClick={applyFilters}
          disabled={loading}
          className="save-btn"
          style={{ padding: "8px 20px" }}
        >
          {loading ? "Loading..." : "Apply Filter"}
        </button>
        <button
          onClick={clearFilters}
          disabled={loading}
          className="remove-btn"
          style={{ padding: "8px 20px" }}
        >
          Clear
        </button>
      </div>

      {loading ? (
        <div style={{ textAlign: "center", padding: 40 }}>Loading payments...</div>
      ) : (
        <CompanyPayments data={payments} />
      )}
    </div>
  );
};

export default CompanyPaymentsPage;